import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { observable, computed } from 'mobx';
import moment from 'moment';
import StepRangeSlider from 'react-step-range-slider';
import { action, toJS } from "mobx";
import _ from 'lodash';
import Form, { FormBody, DateInput, SelectInput, FormActions } from "../../../Form";
import { getDisplayDate } from '../../../../libs/date';
import { BASE_URL } from "../../../../config";

@inject("stationImageStore", 'imageTagStore')
@observer
class Comparison extends Component {
  interval;
  playing;

  @observable isLoading = false;

  @observable filters = {
    date_to: getDisplayDate(moment().endOf("day"), { format: "YYYY-MM-DD" }),
    date_from: getDisplayDate(moment().subtract(1, "day").startOf("day"), { format: "YYYY-MM-DD" }),
    selectedAlbum: 'All',
    filter_date: 'date_taken',
    selectedTime: 0
  }

  @observable filters2 = {
    date_to: getDisplayDate(moment().endOf("day"), { format: "YYYY-MM-DD" }),
    date_from: getDisplayDate(moment().subtract(1, "day").startOf("day"), { format: "YYYY-MM-DD" }),
    selectedAlbum: 'All',
    filter_date: 'date_taken',
    selectedTime: 0
  }

  @observable images1 = [];
  @observable images2 = [];

  @computed get image1FilteredByAlbum() {
    return this.images1.filter(image => this.filters.selectedAlbum === 'All' || image.album_code === this.filters.selectedAlbum)
  }
  @computed get image2FilteredByAlbum() {
    return this.images2.filter(image => this.filters2.selectedAlbum === 'All' || image.album_code === this.filters2.selectedAlbum)
  }

  componentDidMount() {
    this.props.stationImageStore.fetchAlbums(this.props.params.id);

    this.fetchData();
  }

  @action onChangeFilter = (field, value) => this.filters[field] = value;
  @action onChangeFilter2 = (field, value) => this.filters2[field] = value;

  fetchData = (e) => {
    if (e) e.preventDefault();

    const { params: { id } } = this.props;

    let filters1 = {
      station_id: id,
      ..._.pick(this.filters, ['date_from', 'date_to', 'filter_date'])
    };
    let filters2 = {
      station_id: id,
      ..._.pick(this.filters2, ['date_from', 'date_to', 'filter_date'])
    };

    this.images1 = [];
    this.images2 = [];

    this.filters.selectedTime = 0;
    this.filters.selectedTime = 2;

    this.props.stationImageStore.fetchStationComparisonImages(filters1, filters2).then(res => {
      this.images1 = res[0];
      this.images2 = res[1];
    })
  }

  @action onChangeSelectedTime = value => {
    if (this.interval) {
      clearInterval(this.interval);
      this.playing = false;
      this.interval = null;
    }

    this.filters.selectedTime = value;
  }

  @action onChangeSelectedTime2 = value => {
    if (this.interval) {
      clearInterval(this.interval);
      this.playing = false;
      this.interval = null;
    }

    this.filters2.selectedTime = value;
  }

  returnSelectedTimeRange = (images, album) => {
    let key = 'date_taken';
    let timeRange = {};
    let filteredImages = [];

    images.forEach(image => {
      const time = image[key];

      const date = moment(time).seconds(0).valueOf();

      if (!timeRange[date]) timeRange = Object.assign(timeRange, { [date]: time });
    });

    return Object.keys(timeRange).sort((a, b) => +a < +b ? -1 : 1).map((key, index) => ({
      value: index,
      epoch: key,
      date: timeRange[key]
    }));
  }

  @action
  onChangeTags = (tags) => {
    console.log(tags);

    const { filter_date, selectedTime } = this.state;
    const { stationImageStore, imageTagStore, params: { id } } = this.props;

    const { stationImages } = stationImageStore;
    const { updateImageTags } = imageTagStore;

    const dateRange = this.returnSelectedTimeRange();
    const selectedStationImage = stationImages.find(image => dateRange && dateRange.length > 0 && image[filter_date] && dateRange[selectedTime] && image[filter_date] === dateRange[selectedTime].date);

    const { album_code, date_taken } = selectedStationImage;

    // selectedStationImage.tags.replace(tags);

    updateImageTags({
      station_id: id,
      album_code,
      date_taken,
      tags: tags.map(tag => tag.id)
    }).then(res => {
      console.log(res);
    });
  }

  _renderImage = (selectedStationImage, dateRange, selectedTime, onChangeSelectedTime) => {
    return (
      <div className='flex flex-column'>
        <div className='flex flex-row'>
          <img style={{ width: 'auto', height: "25vh", minHeight: '220px' }} src={`${BASE_URL}/idaq-files/${selectedStationImage.source}`} alt='not-found' />
          <div className='DataTable' style={{ flex: 1, display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingLeft: '20px', flexDirection: 'column' }}>
            <table>
              <tbody>
                <tr><th>Album</th><td>{selectedStationImage.album_code}</td></tr>
                <tr><th>Date Taken</th><td>{getDisplayDate(selectedStationImage.date_taken)}</td></tr>
                <tr><th>Date Created</th><td>{getDisplayDate(selectedStationImage.date_created)}</td></tr>
                <tr><th>Date Modified</th><td>{selectedStationImage.date_modified && getDisplayDate(selectedStationImage.date_modified)}</td></tr>
                <tr><th>Angle</th><td>{selectedStationImage.direction}</td></tr>
                <tr><th>Status</th><td>{selectedStationImage.status}</td></tr>
                <tr><th>Rating</th><td>{selectedStationImage.rating}</td></tr>
                <tr><th>File Name</th><td>{selectedStationImage.file_name}</td></tr>
              </tbody>
            </table>
          </div>
        </div>
        {dateRange.length > 0 && <StepRangeSlider ref={(ref) => this.ref = ref} value={selectedTime} range={dateRange} onChange={onChangeSelectedTime} children={null} />}
        {!!dateRange[selectedTime] && <span style={{
          marginLeft: `calc(${(selectedTime / (dateRange.length - 1)) * 100}% - (${(selectedTime / (dateRange.length - 1)) * 126}px))`,
          whiteSpace: 'nowrap',
          transition: '0.1s linear'
        }}>{getDisplayDate(dateRange[selectedTime].date, { format: 'YYYY-MM-DD HH:mm' })}</span>}
      </div>
    )
  }

  render() {
    const { stationAlbums } = this.props.stationImageStore;

    const dateRange = !!this.images1 && !!this.images1.length && this.returnSelectedTimeRange(this.image1FilteredByAlbum);
    const selectedStationImage = this.image1FilteredByAlbum.find(image => dateRange && dateRange.length > 0 && image[this.filters.filter_date] && dateRange[this.filters.selectedTime] && image[this.filters.filter_date] === dateRange[this.filters.selectedTime].date);

    const dateRange2 = !!this.images2 && !!this.images2.length && this.returnSelectedTimeRange(this.image2FilteredByAlbum);
    const selectedStationImage2 = this.image2FilteredByAlbum.find(image => dateRange2 && dateRange2.length > 0 && image[this.filters2.filter_date] && dateRange2[this.filters2.selectedTime] && image[this.filters2.filter_date] === dateRange2[this.filters2.selectedTime].date);

    return (
      <div>
        <div>
          <Form>
            <FormBody>
              <div className='flex flex-row'>
                <div>
                  <SelectInput
                    label={'Album 1'}
                    value={this.filters.selectedAlbum}
                    fields={{ label: 'album_code', value: 'album_code' }}
                    options={stationAlbums}
                    onChange={e => this.onChangeFilter('selectedAlbum', e.target.value)}
                    defaultValue={'All'}
                  />
                  <DateInput
                    label={'Date From'}
                    value={this.filters.date_from}
                    onChange={e => this.onChangeFilter('date_from', e.target.value)}
                  />
                  <DateInput
                    label={'Date To'}
                    value={this.filters.date_to}
                    onChange={e => this.onChangeFilter('date_to', e.target.value)}
                  />
                </div>
                <div>
                  <SelectInput
                    label={'Album 2'}
                    value={this.filters2.selectedAlbum}
                    fields={{ label: 'album_code', value: 'album_code' }}
                    options={stationAlbums}
                    onChange={e => this.onChangeFilter2('selectedAlbum', e.target.value)}
                    defaultValue={'All'}
                  />
                  <DateInput
                    label={'Date From'}
                    value={this.filters2.date_from}
                    onChange={e => this.onChangeFilter2('date_from', e.target.value)}
                  />
                  <DateInput
                    label={'Date To'}
                    value={this.filters2.date_to}
                    onChange={e => this.onChangeFilter2('date_to', e.target.value)}
                  />
                </div>
              </div>
            </FormBody>
            <FormActions>
              <button onClick={this.fetchData}>View</button>
            </FormActions>
          </Form>

          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <div className='flex flex-column'>
              {selectedStationImage && this._renderImage(selectedStationImage, dateRange, this.filters.selectedTime, this.onChangeSelectedTime)}
              <br />
              {selectedStationImage2 && this._renderImage(selectedStationImage2, dateRange2, this.filters2.selectedTime, this.onChangeSelectedTime2)}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Comparison;


// WEBPACK FOOTER //
// ./src/components/Station/Image/pages/Comparison.js